import React, { useMemo, useRef } from "react";
import _ from "lodash";
import { DataGrid } from "@toddle-edu/ds-data-grid";
import { getHeadersWithScaledWidths } from "TranscriptsV2/module/Utils";
import { useContainerWidth } from "Hooks";

const SKELETON_ROW_COUNT = 8;
const SKELETON_COLUMN_COUNT = 6;

const SkeletonLoaderDataGrid = () => {
  const containerRef = useRef();
  const containerWidth = useContainerWidth({ containerRef });

  const headers = useMemo(() => {
    const initialHeaders = _.times(SKELETON_COLUMN_COUNT, index => ({
      id: `skeleton-header-${index}`,
      label: "",
      width: index === 0 ? 500 : 120,
      minWidth: index === 0 ? 500 : 120,
      ...(index === 0 ? {} : { maxWidth: 120 }),
    }));

    return getHeadersWithScaledWidths({
      headers: initialHeaders,
      containerWidth,
    });
  }, [containerWidth]);

  const tableData = useMemo(
    () =>
      _.times(SKELETON_ROW_COUNT, rowIndex => ({
        rowId: `skeleton-row-${rowIndex}`,
        columns: _.times(SKELETON_COLUMN_COUNT, () => ({
          cellType: "skeleton",
          isEditable: false,
        })),
      })),
    []
  );

  return (
    <div ref={containerRef}>
      <DataGrid
        data={tableData}
        headers={headers}
        rowMarkers="none"
        roundedCorners={false}
        dataGridHeight="400px"
        rowHeight={44}
        headerHeight={44}
        testId="transcript-records-skeleton-loader"
        isViewMode={true}
      />
    </div>
  );
};

export default SkeletonLoaderDataGrid;
